import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BrocasRecomendadasParaMachuelearRoscasPulgadas } from 'src/app/constants/tablas-utiles';
import { advertisement, ServiceService } from 'src/app/service.service';

@Component({
  selector: 'app-brocas-recmen-machuelear-rosc-pulg',
  templateUrl: './brocas-recmen-machuelear-rosc-pulg.page.html',
  styleUrls: ['./brocas-recmen-machuelear-rosc-pulg.page.scss'],
})
export class BrocasRecmenMachuelearRoscPulgPage implements OnInit {
  public sizeBrocaRecommendedForm:FormGroup = null;
  public response:string = '';
  public drillBroachSize:Array<any> = [];
  previousResult:string = null;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();
  constructor(public services:ServiceService, private formBuilder:FormBuilder) {
    this.sizeBrocaRecommendedForm = this.formBuilder.group({
      drillBroach: ['', Validators.required ],
      textSearch: [''],
    });
    this.drillBroachSize = [...BrocasRecomendadasParaMachuelearRoscasPulgadas];
  }

  async ngOnInit() {
    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(8,1);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  reset(){
    this.sizeBrocaRecommendedForm.reset();
    // this.response = '';
    this.drillBroachSize = [...BrocasRecomendadasParaMachuelearRoscasPulgadas];
  }

  search(ev:any){
    this.sizeBrocaRecommendedForm.controls.drillBroach.setValue(undefined);
    this.drillBroachSize = [...BrocasRecomendadasParaMachuelearRoscasPulgadas].filter(
      (drill)=>new RegExp(ev.target.value,'gmi').test(`${drill.designacion} - ${drill.hilosPorPulgada}`)
    );
  }
  isSharing:boolean = false;
  calcular(){
    if(!this.sizeBrocaRecommendedForm.valid)
      return;

    let drillSelected = this.drillBroachSize[this.sizeBrocaRecommendedForm.controls.drillBroach.value];
    this.response = `<br>
    Tamaño de broca requerido: <br>
    ${drillSelected.tamanoBrocaRequerido}" (pulgadas)
    <br>
    Hilos por pulgada: <br>
    ${drillSelected.hilosPorPulgada}"
    `;
    // despues de procesar respuesta
    if(this.previousResult != this.response && !this.isSharing){
      this.previousResult = this.response;
      this.isSharing = true;
      setTimeout(()=>{ this.isSharing = false; },20000);
      this.services.addPointCalculator();
    }
  }
}
